import React from 'react';

const TooltipContentReaxysExamples = () =>
  <div className="rs-tooltip-big__content info-tooltip-content tooltip-content-reaxys-examples">
    Published reactions from patents and journals
  </div>;

export default TooltipContentReaxysExamples;
